import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemOrderAutoCancellationModal } from '@/types/modal';
import { useItem, useUpdateItemOrderCancellation } from '@/hooks/item';
import { ErrorModal, StandardModal, NoFooterModal, SuccessModal } from '@/components/molecules/common/Modal';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import styles from './Modal.module.scss';
import { Skeleton } from '@mui/material';

const View: React.FC<{ modal: ItemOrderAutoCancellationModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const [isCancelled, setIsCancelled] = useState(item.isAutoCancelSale);
  const itemR = useItem(item.productId, false);
  const submitR = useUpdateItemOrderCancellation(item.productId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Loading') {
    return (
      <NoFooterModal
        title={t('modal.update_item_order_cancellation.title')}
        body={
          <>
            <Skeleton
              height={20}
              variant="rounded"
            />
            <div className={styles.updateItemAttributeWait}>{t('modal.update_item_order_cancellation.waiting')}</div>
          </>
        }
        onClose={onClose}
        modalName="item_order_auto_cancellation"
      />
    );
  }

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.update_item_order_cancellation.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  }

  if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.update_item_order_cancellation.title')}
        onClose={onClose}
      />
    );
  }

  const body = (
    <div className={styles.flex100}>
      <div className={styles.height1rem} />
      <div className={styles.text1rem}>{t('modal.update_item_order_cancellation.description')}</div>
      <div className={styles.height1rem} />
      <FormControlLabel
        control={
          <Switch
            checked={isCancelled}
            onChange={() => {
              setIsCancelled(!isCancelled);
            }}
          />
        }
        label={isCancelled ? t('common.on') : t('common.off')}
      />
    </div>
  );

  const onSubmit = () => {
    submitR.mutate({
      autoCancelSale: isCancelled,
    });
  };

  return (
    <StandardModal
      title={t('modal.update_item_order_cancellation.title')}
      onClose={onClose}
      onSubmit={onSubmit}
      submittable={true}
      body={body}
      containerStyle={{ maxWidth: 650 }}
      modalName="update_item_order_cancellation"
    />
  );
};

export default View;
